import { useState, useEffect } from 'react'
import ARAgingGrid from './Components/GridComponents/ARAgingGrid'
import styles from './ARAgingDashboard.module.scss'
import useAgent from './Hook/useAgent'
import { aggregates, pageDataState, useDashboardContext } from './Context/DashboardContext'
import { ToggleButtons } from '../GlobalComponents/Inputs/Inputs'
import {
    createAppState,
    processWithGroups,
    sortData,
} from './Components/GridComponents/ARAgingGridFunctions'
import { setExpandedState } from '@progress/kendo-react-data-tools'

export default function ARAgingDashboard() {
    enum INVOICE_RANGE {
        'All' = 0,
        'Over15Days' = 1,
    }

    const { setDataAvailable, setAppState, setDataState, setCollapsedState, setOperationsResult } =
        useDashboardContext()
    //I had to add a state variable since the context would not refresh with the async call in the useEffect
    const [arData, setArData] = useState<ARAgingGridInvoice[] | undefined>([])
    const { agent } = useAgent<ARAgingGridInvoice>()

    const [invoiceRange, setInvoiceRange] = useState<INVOICE_RANGE>(1)
    useEffect(() => {
        document.getElementsByTagName('html')[0].classList.add(styles.ARAgingDashboard)
    }, [])

    useEffect(() => {
        const getData = async () => {
            const responseList = await agent.ARGridInvoices.list(invoiceRange)
            if (responseList) {
                const sortedData = sortData(responseList)
                setArData(sortedData)
            }
        }
        getData()
    }, [invoiceRange])

    useEffect(() => {
        if (arData) {
            setDataAvailable(arData)
            setDataState(pageDataState)
            setCollapsedState([])
            const operations = processWithGroups(arData ? arData : [], pageDataState, aggregates)
            setOperationsResult(operations)
            const data = setExpandedState({
                data: operations.data,
                collapsedIds: [],
            })

            const result = createAppState(0, 5, data)
            setAppState(result)
        }
    }, [arData])

    return (
        <>
            <div className={styles.ARAContainer}>
                <div className={styles.ARAHeader}>
                    <h1>Past Due Reconciliation</h1>
                    <div>
                        <span style={{ textAlign: 'right', marginRight: '1em' }}>
                            Transactions Displayed:
                        </span>
                        <ToggleButtons
                            buttonText={['Show All', '16+ Days Past Due']}
                            selectedIndex={invoiceRange}
                            onChange={(newSelectedIndex) => setInvoiceRange(newSelectedIndex)}
                        />
                    </div>
                </div>
            </div>
            {agent.ARGridInvoices.isLoading ? (
                <>
                    <div
                        className={'k-i-loading'}
                        style={{
                            fontSize: 200,
                            position: 'fixed',
                            top: '50%',
                            right: '50%',
                        }}
                    ></div>
                </>
            ) : (
                <>
                    {arData && arData.length > 0 ? (
                        <div className={styles.ARATableContainer}>
                            <ARAgingGrid />
                        </div>
                    ) : (
                        <div style={{ fontSize: '18px', textAlign: 'center' }}>
                            No data available
                        </div>
                    )}
                </>
            )}
        </>
    )
}
